var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "tile is-parent is-half" }, [
    _c(
      "article",
      { staticClass: "tile is-child box" },
      [
        _c("div", { staticClass: "columns is-gapless" }, [
          _vm._m(0),
          _c("div", { staticClass: "column" }, [
            !_vm.gstPaid && !_vm.readOnlyView
              ? _c("div", { staticClass: "field is-pulled-right" }, [
                  _c("p", { staticClass: "buttons" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "button is-primary tooltip is-tooltip-topright",
                        attrs: { "data-tooltip": "Add new item" },
                        on: {
                          click: function ($event) {
                            return _vm.toggleQuickItemList()
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "icon" }, [
                          _c("i", {
                            staticClass: "mdi",
                            class: {
                              "mdi-plus": !_vm.isQuickItemListActive,
                              "mdi-minus": _vm.isQuickItemListActive,
                            },
                          }),
                        ]),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.isQuickItemListActive ? "Close" : "Add")
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "button",
                      {
                        staticClass:
                          "button is-primary tooltip is-tooltip-topright",
                        attrs: { "data-tooltip": "Add blank item" },
                        on: { click: _vm.addBlankItem },
                      },
                      [_vm._m(1)]
                    ),
                  ]),
                ])
              : _vm._e(),
          ]),
        ]),
        false ? _c("div", { staticClass: "field" }, [_vm._m(2)]) : _vm._e(),
        _c("quickinvoice-item-list", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isQuickItemListActive,
              expression: "isQuickItemListActive",
            },
          ],
          attrs: {
            "invoice-id": _vm.innerValue.invoiceId,
            "invoice-gl-account": _vm.innerValue.invoiceGlCode,
            "gst-rate": _vm.innerValue.gstRate,
          },
          model: {
            value: _vm.innerValue.items,
            callback: function ($$v) {
              _vm.$set(_vm.innerValue, "items", $$v)
            },
            expression: "innerValue.items",
          },
        }),
        _c("div", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isQuickItemListActive,
              expression: "isQuickItemListActive",
            },
          ],
          staticClass: "is-divider",
        }),
        _c("div", { staticClass: "column" }, [
          _c("div", { staticClass: "control is-pulled-left" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.isOriginalItemListActive,
                  expression: "isOriginalItemListActive",
                },
              ],
              staticClass: "is-checkradio is-circle is-success is-rtl",
              class: { "has-background-color": _vm.isOriginalItemListActive },
              attrs: {
                id: "originalItem",
                name: "originalItem",
                type: "checkbox",
              },
              domProps: {
                checked: Array.isArray(_vm.isOriginalItemListActive)
                  ? _vm._i(_vm.isOriginalItemListActive, null) > -1
                  : _vm.isOriginalItemListActive,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.isOriginalItemListActive,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 &&
                        (_vm.isOriginalItemListActive = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.isOriginalItemListActive = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.isOriginalItemListActive = $$c
                  }
                },
              },
            }),
            _c(
              "label",
              { staticClass: "label", attrs: { for: "originalItem" } },
              [_vm._v("Original Invoice Misc")]
            ),
          ]),
        ]),
        _c("div", { staticClass: "column" }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isOriginalItemListActive,
                  expression: "isOriginalItemListActive",
                },
              ],
            },
            [
              _c(
                "table",
                {
                  staticClass:
                    "table is-bordered is-striped is-narrow is-fullwidth",
                },
                [
                  _vm._m(3),
                  _c("tfoot", { staticClass: "no-border" }, [
                    _c(
                      "tr",
                      {
                        class: `debtor-adjustment-background-success-${_vm.$theme.name}`,
                      },
                      [
                        _c(
                          "th",
                          {
                            staticClass: "has-text-left",
                            attrs: { colspan: "3" },
                          },
                          [_vm._v("Totals")]
                        ),
                        _c("th", { staticClass: "has-text-right" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.formatCurrency(
                                _vm.innerValue.applyToTotalIncGst,
                                _vm.$userInfo.locale
                              )
                            )
                          ),
                        ]),
                        _c("th", { staticClass: "has-text-right" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.formatCurrency(
                                _vm.innerValue.applyToGst,
                                _vm.$userInfo.locale
                              )
                            )
                          ),
                        ]),
                        _c("th", { attrs: { colspan: "1" } }),
                      ]
                    ),
                  ]),
                  _c(
                    "tbody",
                    _vm._l(_vm.activeOriginalItems, function (item, index) {
                      return _c("tr", { key: item.invoiceItemId }, [
                        _c("td", [_vm._v(_vm._s(item.invoiceItemDesc))]),
                        _c("td", { staticClass: "has-text-right" }, [
                          _vm._v(_vm._s(item.quantity)),
                        ]),
                        _c("td", { staticClass: "has-text-right" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.formatNumber(
                                item.unitPrice,
                                _vm.$userInfo.locale
                              )
                            )
                          ),
                        ]),
                        _c("td", { staticClass: "has-text-right" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.formatNumber(
                                item.totalIncGst,
                                _vm.$userInfo.locale
                              )
                            )
                          ),
                        ]),
                        _c("td", { staticClass: "has-text-right" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.formatNumber(
                                item.gst,
                                _vm.$userInfo.locale
                              )
                            )
                          ),
                        ]),
                        _c("td", { staticClass: "is-nowrap" }, [
                          _vm._v(
                            _vm._s(_vm.activeOriginalItems[index].invoiceGlCode)
                          ),
                        ]),
                      ])
                    }),
                    0
                  ),
                ]
              ),
              _c("div", { staticClass: "is-divider" }),
            ]
          ),
          _vm._m(4),
          _c(
            "table",
            {
              staticClass:
                "table is-bordered is-striped is-narrow is-fullwidth",
            },
            [
              _c("thead", [
                _c("tr", [
                  _c("th", [_vm._v("Description")]),
                  _c("th", { staticClass: "has-text-right" }, [_vm._v("Qty")]),
                  _c("th", { staticClass: "has-text-right" }, [
                    _vm._v(" Unit Price "),
                  ]),
                  _c("th", { staticClass: "has-text-right" }, [
                    _vm._v("Inc. GST"),
                  ]),
                  _c("th", { staticClass: "has-text-right" }, [_vm._v("GST")]),
                  _c("th", [_vm._v("G/L Account")]),
                  !_vm.gstPaid && !_vm.readOnlyView ? _c("th") : _vm._e(),
                ]),
              ]),
              _c("tfoot", { staticClass: "no-border" }, [
                _c(
                  "tr",
                  {
                    class: `debtor-adjustment-background-success-${_vm.$theme.name}`,
                  },
                  [
                    _c(
                      "th",
                      { staticClass: "has-text-left", attrs: { colspan: "3" } },
                      [_vm._v("Totals")]
                    ),
                    _c("th", { staticClass: "has-text-right" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$filters.formatCurrency(
                            _vm.innerValue.totalIncGst,
                            _vm.$userInfo.locale
                          )
                        )
                      ),
                    ]),
                    _c("th", { staticClass: "has-text-right" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$filters.formatCurrency(
                            _vm.innerValue.gst,
                            _vm.$userInfo.locale
                          )
                        )
                      ),
                    ]),
                    _c("th", { attrs: { colspan: "2" } }),
                  ]
                ),
              ]),
              _vm.gstPaid || _vm.readOnlyView
                ? _c(
                    "tbody",
                    _vm._l(_vm.activeItems, function (item, index) {
                      return _c("tr", { key: item.invoiceItemId }, [
                        _c("td", [_vm._v(_vm._s(item.invoiceItemDesc))]),
                        _c("td", { staticClass: "has-text-right" }, [
                          _vm._v(_vm._s(item.quantity)),
                        ]),
                        _c("td", { staticClass: "has-text-right" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.formatNumber(
                                item.unitPrice,
                                _vm.$userInfo.locale
                              )
                            )
                          ),
                        ]),
                        _c("td", { staticClass: "has-text-right" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.formatNumber(
                                item.totalIncGst,
                                _vm.$userInfo.locale
                              )
                            )
                          ),
                        ]),
                        _c("td", { staticClass: "has-text-right" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.formatNumber(
                                item.gst,
                                _vm.$userInfo.locale
                              )
                            )
                          ),
                        ]),
                        _vm.selectedItemAccounts.length > 0
                          ? _c("td", { staticClass: "is-nowrap" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.selectedItemAccounts[index].displayName
                                )
                              ),
                            ])
                          : _vm._e(),
                      ])
                    }),
                    0
                  )
                : _c(
                    "tbody",
                    _vm._l(_vm.activeItems, function (item, index) {
                      return _c("tr", { key: item.invoiceItemId }, [
                        _c("td", [
                          _c("textarea", {
                            directives: [
                              {
                                name: "focus-inserted",
                                rawName: "v-focus-inserted",
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: item.invoiceItemDesc,
                                expression: "item.invoiceItemDesc",
                              },
                            ],
                            staticClass: "textarea",
                            class: {
                              "is-danger":
                                !_vm.$v.entity.items.$each[index]
                                  .invoiceItemDesc.required,
                            },
                            attrs: {
                              placeholder: "Item Description",
                              rows: "2",
                            },
                            domProps: { value: item.invoiceItemDesc },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  item,
                                  "invoiceItemDesc",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                        _c(
                          "td",
                          { staticClass: "has-text-right quantity-input" },
                          [
                            _c("vue-numeric", {
                              staticClass: "input has-text-right",
                              attrs: { min: 0, max: 99, precision: 0 },
                              on: {
                                input: function ($event) {
                                  return _vm.updateItem(item)
                                },
                              },
                              model: {
                                value: item.quantity,
                                callback: function ($$v) {
                                  _vm.$set(item, "quantity", _vm._n($$v))
                                },
                                expression: "item.quantity",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "td",
                          { staticClass: "has-text-right money-input" },
                          [
                            _c("vue-numeric", {
                              staticClass: "input has-text-right",
                              attrs: { minus: true, precision: 2 },
                              on: {
                                input: function ($event) {
                                  return _vm.updateItem(item)
                                },
                              },
                              model: {
                                value: item.unitPrice,
                                callback: function ($$v) {
                                  _vm.$set(item, "unitPrice", _vm._n($$v))
                                },
                                expression: "item.unitPrice",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "td",
                          { staticClass: "has-text-right money-input" },
                          [
                            _c("vue-numeric", {
                              staticClass: "input has-text-right is-static",
                              attrs: {
                                value: item.totalIncGst,
                                precision: 2,
                                readonly: "",
                                tabindex: "-1",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "td",
                          { staticClass: "has-text-right money-input" },
                          [
                            _c("vue-numeric", {
                              staticClass: "input has-text-right",
                              attrs: { minus: true, precision: 2 },
                              on: {
                                input: function ($event) {
                                  return _vm.updateGstTotal(item)
                                },
                              },
                              model: {
                                value: item.gst,
                                callback: function ($$v) {
                                  _vm.$set(item, "gst", _vm._n($$v))
                                },
                                expression: "item.gst",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "td",
                          { staticClass: "account-input" },
                          [
                            _vm.glAccountListCombo &&
                            _vm.selectedItemAccounts.length > 0
                              ? _c(
                                  "multiselect",
                                  {
                                    attrs: {
                                      options: _vm.glAccountListCombo,
                                      placeholder: "Select account",
                                      label: "displayName",
                                      "track-by": "accountNo",
                                      "deselect-label":
                                        "Can't remove this value",
                                      "show-labels": false,
                                      "allow-empty": false,
                                    },
                                    model: {
                                      value: _vm.selectedItemAccounts[index],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.selectedItemAccounts,
                                          index,
                                          $$v
                                        )
                                      },
                                      expression: "selectedItemAccounts[index]",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "has-text-danger",
                                        attrs: { slot: "noResult" },
                                        slot: "noResult",
                                      },
                                      [_vm._v("G/L account not found.")]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(
                          "td",
                          {
                            staticClass:
                              "has-vertical-middle has-text-centered is-content-width",
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "button is-danger is-small is-inverted",
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteItem(item, index)
                                  },
                                },
                              },
                              [_vm._m(5, true)]
                            ),
                          ]
                        ),
                      ])
                    }),
                    0
                  ),
            ]
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "column" }, [
      _c("p", { staticClass: "title" }, [_vm._v("Invoice Items")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-shape-square-plus" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "field is-horizontal" }, [
      _c("div", { staticClass: "field-body" }, [
        _c("div", { staticClass: "field-body" }, [
          _c("div", { staticClass: "field has-addons" }, [
            _c(
              "div",
              { staticClass: "control has-icons-left has-icons-right" },
              [
                _c("input", {
                  staticClass: "input",
                  attrs: {
                    type: "text",
                    placeholder: "Start typing to filter",
                  },
                }),
                _c("span", { staticClass: "icon is-left" }, [
                  _c("i", { staticClass: "mdi mdi-magnify mdi-18px" }),
                ]),
              ]
            ),
            _c("div", { staticClass: "control" }, [
              _c("a", { staticClass: "button is-primary is-outlined" }, [
                _c("span", { staticClass: "icon" }, [
                  _c("i", { staticClass: "mdi mdi-close mdi-18px" }),
                  _vm._v("> "),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Description")]),
        _c("th", { staticClass: "has-text-right" }, [_vm._v("Qty")]),
        _c("th", { staticClass: "has-text-right" }, [_vm._v(" Unit Price ")]),
        _c("th", { staticClass: "has-text-right" }, [_vm._v("Inc. GST")]),
        _c("th", { staticClass: "has-text-right" }, [_vm._v("GST")]),
        _c("th", [_vm._v("G/L Account")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "column" }, [
      _c("label", { staticClass: "label" }, [_vm._v("Selected Misc")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-medium" }, [
      _c("i", { staticClass: "mdi mdi-delete mdi-24px" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }